export interface Category {
  id: string;
  name: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Schuhe',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Sneakers, Laufschuhe & mehr',
  },
  {
    id: 'hoodies',
    name: 'Hoodies & Sweater',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Gemütliche Hoodies & Pullover',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Streetwear & Basic Tees',
  },
  {
    id: 'jackets',
    name: 'Jacken',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloudy-line',
    description: 'Winterjacken & leichte Jacken',
  },
  {
    id: 'pants',
    name: 'Hosen & Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    description: 'Jeans, Cargohosen & mehr',
  },
  {
    id: 'headwear',
    name: 'Kopfbedeckungen',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-archive-line',
    description: 'Caps, Beanies & Hüte',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Komplette Outfit-Sets',
  },
  {
    id: 'underwear',
    name: 'Unterwäsche',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Boxershorts & Basics',
  },
  {
    id: 'jersey',
    name: 'Trikots',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    description: 'Fußball- & Sporttrikots',
  },
  {
    id: 'accessories',
    name: 'Accessoires',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Schmuck, Uhren & Brillen',
  },
  {
    id: 'bags',
    name: 'Taschen',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Rucksäcke, Taschen & Koffer',
  },
  {
    id: 'belts',
    name: 'Gürtel',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-links-line',
    description: 'Ledergürtel & Designer-Gürtel',
  },
  {
    id: 'perfumes',
    name: 'Parfums',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Düfte & Designer-Parfums',
  },
  {
    id: 'other',
    name: 'Sonstiges',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Weitere Produkte entdecken',
  },
];